import axios from 'axios'
import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesStoreProducts = {
  namespaced: true,
  state: {
    data: null,
    meta: null,
    loading: false
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    readStoreProductsSuccess(state, payload) {
      state.data = payload.data.map(v => {
        const result = castAttributesForCamelCase(v.attributes)
        result.gmbSyncResult = castAttributesForCamelCase(result.gmbSyncResult)
        result.id = v.id
        return result
      })
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    readStoreProductsFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readStoreProducts({ commit, rootState } ) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/location/stores/${rootState.route.params.store_uuid}/products.json` + window.location.search)
        .then(res => {
          commit('readStoreProductsSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreProductsFailure')
          if(err.response.status !== 404) {
            commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          }
        })
    },
  }
}
